import type { QueryKey } from "@tanstack/react-query";
import type { QueryScope } from "@/queries/scope";
import type { THintTargets } from "./types";

/**
 * Every cached team read in `scope`: the lists (R14, R15) under `teams`, a
 * team, its roster and its sub-teams (R16-R18) under `team`, and a member's
 * teams (R19).
 */
function isTeamRead(scope: QueryScope, queryKey: QueryKey): boolean {
  if (queryKey[0] !== scope.tenant || queryKey[1] !== scope.principal) return false;
  if (queryKey[2] === "teams" || queryKey[2] === "team") return true;
  return queryKey.length === 5 && queryKey[2] === "member" && queryKey[4] === "teams";
}

/**
 * The teams domain's hint rows (NG-2796). The teams domain reads only through
 * Query, so the row runs whatever the `query-cache` flag says.
 */
export const TEAMS_HINTS: THintTargets = {
  // `teams:bank` is published for a team write and for a change to who is on a
  // team, so every team read is marked: an open picker, the teams page, an open
  // team's page and its Members tab all re-read, as `observedRead` does.
  "teams:bank": {
    flag: null,
    mark: (_root, _slug, { client, scope }) =>
      void client.invalidateQueries({
        predicate: ({ queryKey }) => isTeamRead(scope, queryKey),
        refetchType: "none",
      }),
    reread: (_root, _slug, { client, scope }) =>
      void client.refetchQueries({
        predicate: ({ queryKey }) => isTeamRead(scope, queryKey),
        type: "active",
        stale: true,
      }),
  },
};
